import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  Events,
  AlertController,
} from "ionic-angular";
import { HttpClient } from "../../../services/HttpClient";

import { PublicationPage } from "./publication/publication";
import { AddPublicationPage } from "./addPublication/addPublication";

import { CustomToast } from "../../../util/CustomToast";

@Component({
  selector: "page-publications",
  templateUrl: "publications.html",
  providers: [HttpClient, CustomToast],
})
export class PublicationsPage {
  notOwnPublications = [];
  ownPublications = [];
  selectPublications = [];

  user;

  modalCtrl: ModalController;

  httpClient: HttpClient;
  searchQuery = "";
  events: Events;
  customToast: CustomToast;
  alertCtrl: AlertController;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    httpClient: HttpClient,
    modalCtrl: ModalController,
    events: Events,
    customToast: CustomToast,
    alertCtrl: AlertController
  ) {
    this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.events = events;
    this.customToast = customToast;
    this.alertCtrl = alertCtrl;
    this.events.subscribe("addPublication:done", () => {
      this.httpCallPublications("", 1000);
    });
    this.events.subscribe("publication:update", () => {
      this.httpCallPublications("", 1000);
    });
    this.events.subscribe("publication:delete", () => {
      this.httpCallPublications("", 1000);
    });
    this.httpCallPublications("", 1000);
  }

  httpCallPublications(name, max) {
    this.httpClient.get("/users/me", (error, data) => {
      this.user = data.json();
      if (this.user.role == 1 || this.user.role == 4) {
        this.httpCallAllPublications(name, max);

      } else {
        this.httpCallSelectPublications(name, max);
        this.httpCallOwnPublications(name, max);
        this.httpCallNotOwnPublications(name, max);
      }
    });
  }

  httpCallSelectPublications(name, max) {
    //GetNotOwnPublications
    this.httpClient.get(
      "/publications?name=" +name+ "&idUser=" + this.user.id + "&role=2&select=true&max=" + max,
      (error, data) => {
        this.selectPublications = data.json();
      }
    );
  }

  httpCallOwnPublications(name, max) {
    //GetOwnPublications
    this.httpClient.get(
      "/publications?name=" +name+ "&idUser=" + this.user.id + "&role=2&own=true&max=" + max,
      (error, data) => {
        this.ownPublications = data.json();
      }
    );
  }

  httpCallNotOwnPublications(name, max) {
    //GetNotOwnPublications
    this.httpClient.get(
      "/publications?name=" +name+ "&idUser=" + this.user.id + "&role=2&max=" + max,
      (error, data) => {
        this.notOwnPublications = data.json();
      }
    );
  }

  httpCallAllPublications(name, max) {
    //GetAllPublications
    this.httpClient.get(
      "/publications?name=" +name+ "&idUser=" + this.user.id + "&role=1&max=" + max,
      (error, data) => {
        this.notOwnPublications = data.json();
      }
    );
  }

  httpCallUnselectPublication(publication) {
    this.httpClient.delete(
      "/users/me/publications/" + publication.id,
      (error, data) => {
        this.customToast.showMessage(
          "Has deseleccionado la publicación correctamente.",
          4000
        );
        this.httpCallPublications("", 1000);
      }
    );
  }

  httpCallSelectPublication(publication) {
    this.httpClient.post(
      "/users/me/publications",
      publication,
      (error, data) => {
        this.customToast.showMessage(
          "Has seleccionado la publicación correctamente.",
          4000
        );
        this.httpCallPublications("", 1000);
      }
    );
  }

  onSearch() {
    if (this.searchQuery.length > 0) {
      this.httpCallPublications(this.searchQuery, 50);
    } else {
      this.httpCallPublications(this.searchQuery, 1000);
    }
  }

  onClickPublication(publication) {
    this.navCtrl.push(PublicationPage, { id: publication.id });
  }

  onClickAdd() {
    this.navCtrl.push(AddPublicationPage);
  }

  onClickDisable(publication) {
    let alert = this.alertCtrl.create({
      title: "¿Estas seguro?",
      message: "Vas a deseleccionar una publicación.",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.httpCallUnselectPublication(publication);
          },
        },
      ],
    });
    alert.present();
  }

  onClickEnable(publication) {
    if (this.selectPublications.length >= 5) {
      this.customToast.showMessage(
        "No puedes seleccionar más de 5 publicaciones",
        4000
      );
    } else {
      let alert = this.alertCtrl.create({
        title: "¿Estas seguro?",
        message: "Vas a seleccionar una publicación.",
        buttons: [
          {
            text: "No",
            role: "cancel",
          },
          {
            text: "Si",
            role: "confirm",
            handler: () => {
              this.httpCallSelectPublication(publication);
            },
          },
        ],
      });
      alert.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/publications/publications.ts